import { render, staticRenderFns } from "./NewPermissionList.vue?vue&type=template&id=1f51ff29&scoped=true"
import script from "./NewPermissionList.vue?vue&type=script&lang=js"
export * from "./NewPermissionList.vue?vue&type=script&lang=js"
import style0 from "./NewPermissionList.vue?vue&type=style&index=0&id=1f51ff29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f51ff29",
  null
  
)

export default component.exports